export default "__VITE_ASSET__DrSPLxE2__"